import { render } from "./UserRoleAssign.vue?vue&type=template&id=78d6ce6b&scoped=true"
import script from "./UserRoleAssign.vue?vue&type=script&lang=js"
export * from "./UserRoleAssign.vue?vue&type=script&lang=js"

import "./UserRoleAssign.vue?vue&type=style&index=0&id=78d6ce6b&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d6ce6b"]])

export default __exports__